'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_MIN_LENGTH = 8;
const DEFAULT_MAX_LENGTH = 25;
(function(RuleKey2) {
  RuleKey2["minLength"] = "min-length";
  RuleKey2["maxLength"] = "max-length";
  RuleKey2["minMaxLength"] = "min-max-length";
  RuleKey2["number"] = "number";
  RuleKey2["symbol"] = "symbol";
  RuleKey2["uppercase"] = "uppercase";
  RuleKey2["lowercase"] = "lowercase";
  RuleKey2["numbersOnly"] = "numbers-only";
  RuleKey2["differentDigits"] = "different-digits";
  RuleKey2["noDigitsSequence"] = "no-digits-sequence";
})(exports.RuleKey || (exports.RuleKey = {}));
function noDigitsSequenceValidator(password) {
  const pattern = "0123456789012345789";
  const reversePattern = "9875432109876543210";
  if ((password == null ? void 0 : password.length) === 1) {
    return true;
  }
  return pattern.indexOf(password) === -1 && reversePattern.indexOf(password) === -1;
}
function differentDigitsValidator(password) {
  return !/^(.)\1+$/.test(password);
}
const passwordValidationRules = {
  [exports.RuleKey.minLength]: (param = DEFAULT_MIN_LENGTH) => (password) => !!password && password.length >= param,
  [exports.RuleKey.maxLength]: (param = DEFAULT_MAX_LENGTH) => (password) => !!password && password.length <= param,
  [exports.RuleKey.minMaxLength]: (param = {}) => (password) => {
    var _a, _b;
    const min = (_a = param.min) != null ? _a : DEFAULT_MIN_LENGTH;
    const max = (_b = param.max) != null ? _b : DEFAULT_MAX_LENGTH;
    return !!password && password.length >= min && password.length <= max;
  },
  [exports.RuleKey.number]: () => (password) => /[0-9]/.test(password),
  [exports.RuleKey.symbol]: () => (password) => /[ \!"#\$%&'\(\)\*\+,\-\.\/\:;\<\=\>\?@\[\]\^_`\{\|\}~]/.test(password),
  [exports.RuleKey.uppercase]: () => (password) => /[A-Z]/.test(password),
  [exports.RuleKey.lowercase]: () => (password) => /[a-z]/.test(password),
  [exports.RuleKey.numbersOnly]: () => (password) => /^[0-9]*$/.test(password),
  [exports.RuleKey.differentDigits]: () => differentDigitsValidator,
  [exports.RuleKey.noDigitsSequence]: () => noDigitsSequenceValidator
};
function getPasswordValidationRules(passwordValidationConditions) {
  return passwordValidationConditions.reduce((result, currRule) => {
    if (typeof currRule === "object" && passwordValidationRules[currRule.name]) {
      const rule = passwordValidationRules[currRule.name](currRule.value);
      if (rule) {
        result[currRule.name] = rule;
      }
    } else {
      const rule = passwordValidationRules[currRule]();
      if (rule) {
        result[currRule] = rule;
      }
    }
    return result;
  }, {});
}

exports.differentDigitsValidator = differentDigitsValidator;
exports.getPasswordValidationRules = getPasswordValidationRules;
exports.noDigitsSequenceValidator = noDigitsSequenceValidator;
exports.passwordValidationRules = passwordValidationRules;
